import { useAppInfo } from 'hooks/useAppInfo'
import { data } from 'pages/AccountInfo/AccountInfoError/data'
import * as semver from 'semver'
import { hasWebViewHeader } from 'utils'
import { Header } from 'components/Header'

import { FlexColumn } from '@interco/inter-ui/components/Flex'
import { Spacing } from '@interco/inter-ui/components/Spacing'
import { interWbNavigate } from '@interco/inter-webview-bridge'
import { Text, Button, Signal } from '@interco/inter-toranja'
import { TextSize, TextType } from '@interco/inter-toranja/dist/components/Atoms/Text/types'

import { AccountInfoErrorInterUI } from './InterUI'

type AccountInfoErrorProps = {
  refetch: () => void
}

export const AccountInfoError = ({ refetch }: AccountInfoErrorProps) => {
  const appInfo = useAppInfo()
  const { language = 'pt-BR', appVersion } = appInfo ?? {}

  const parsedAppVersion = semver.coerce(appVersion)
  if (parsedAppVersion && semver.lte(parsedAppVersion, '14.0.0')) {
    return <AccountInfoErrorInterUI refetch={refetch} />
  }

  const hasHeader = hasWebViewHeader(appVersion)

  const handleRetryButton = () => refetch()
  const handleBackButton = () => interWbNavigate.requestGoBack()

  return (
    <FlexColumn height="100vh">
      {hasHeader && <Header onClick={handleBackButton} isDarkMode={appInfo.isDarkMode} />}

      <FlexColumn alignItems="center" justifyContent="center" height="100%">
        <Signal variant="error" state="enabled" size="large" />

        <Spacing mb="sm" />

        <Text textSize={TextSize.Medium} as="h1" textType={TextType.Title}>
          {data[language].title}
        </Text>

        <Spacing mb="xxs" />

        <Text textSize={TextSize.Large} as="p" textType={TextType.Body}>
          {data[language].description}
        </Text>
      </FlexColumn>

      <FlexColumn className="p-6" gap="1rem">
        <Button
          hierarchy="primary"
          label={data[language].primaryButton}
          onClick={handleRetryButton}
          aria-label={data[language].primaryButton}
          style={{ width: '100%' }}
        />
        <Button
          hierarchy="secondaryOutlined"
          label={data[language].secondaryButton}
          onClick={handleBackButton}
          style={{ width: '100%' }}
        />
      </FlexColumn>
    </FlexColumn>
  )
}
